import React from 'react';
import GlobalParticles from '../components/GlobalParticles';
import MusicPlayer from '../components/MusicPlayer';
import AnnouncementBar from '../components/AnnouncementBar';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import CurrentNovel from '../components/CurrentNovel';
import SneakPeeks from '../components/SneakPeeks';
import EpisodeProgress from '../components/EpisodeProgress';
import BuyEpisodes from '../components/BuyEpisodes';
import TelegramSection from '../components/TelegramSection';
import DonationSection from '../components/DonationSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-darkBg relative isolate">
      <GlobalParticles />
      <div className="relative z-10">
        <AnnouncementBar />
        <Header />
        <HeroSection />
        <CurrentNovel />
        <SneakPeeks />
        <EpisodeProgress />
        <BuyEpisodes />
        <TelegramSection />
        <DonationSection />
        <ContactSection />
        <Footer />
        <MusicPlayer />
      </div>
    </div>
  );
}
